import React from "react";
import Select, { components } from "react-select";
import { Controller } from "react-hook-form";

export default function CustomSelect(props) {
  const { errors, name, control, defaultValue } = props;

  const dropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <i className="fa fa-caret-up" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-caret-down" aria-hidden="true"></i>
        )}
      </components.DropdownIndicator>
    );
  };

  const isValid = () => {
    return !(errors && errors[name]);
  };

  const customSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? "#f7f7f7" : "white",
      color: state.isSelected ? "#333" : null
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#ddd" : isValid() ? "#004581" : "#dc3545",
      // overwrittes hover style
      "&:hover": {
        borderColor: state.isFocused
          ? "#ddd"
          : isValid()
          ? "#004581"
          : "#dc3545"
      }
    }),
    dropdownIndicator: (base, state) => ({
      color: state.isFocused ? "#ddd" : isValid() ? "#004581" : "#dc3545",
      ...base
    }),
    loadingIndicator: (base, state) => ( { ...base, color: '#ffa900' } ),
    indicatorSeparator: () => {}
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: true }}
      onChange={props.onChange}
      defaultValue={defaultValue}
      as={
        <Select
          styles={customSelectStyles}
          components={{ dropdownIndicator }}
          className={name}
          {...props}
        />
      }
    />
  );
}
